module.exports = __webpack_public_path__ + "static/media/take_photo.3f2a2892.mp3";